import { AppStateType } from "@type/index";
import {
  changeHtmlLanguage,
  getBrand,
  getRegionFromUrl,
  getLanguageFromUrl
} from "@util/common";
import { ActionsUnion, createAction } from "../helpers";
// set lang
export const SET_LANGUAGE_REGION = "[app] SET LANGUAGE REGION";
export const SET_ERROR_FLAG = "[app] SET ERROR FLAG";
export const SET_LOGIN_FLAG = "[app] SET LOGIN FLAG";
export const SET_ERROR_MODAL_FLAG = "[app] SET ERROR MODAL FLAG";
export const SET_NOT_FOUND_FLAG = "[app] SET NOT FOUND FLAG";
export const SET_IS_APP = "[app] SET ISAPP";
export const SET_PRODUCT_FILTER_ERROR = "[app] SET PRODUCT FILTER ERROR";
export const SET_OUTFIT_FILTER_ERROR = "[app] SET OUTFIT FILTER ERROR";
export const SET_OUTFIT_ORDER_ERROR = "[app] SET OUTFIT ORDER ERROR";
export const SET_UPLOAD_ERROR_MODAL_FLAG = "[app] SET UPLOAD ERROR MODAL FLAG";
export const SET_OUTFIT_CAHNGE_ORDER_FLAG =
  "[app] SET OUTFIT CAHNGE ORDER FLAG";
export const SET_TAG_DOT_ACTIVE = "[app] SET TAG DOT ACTIVE";

export const Actions = {
  setLanguageRegion: (payload: LanguageRegionType) =>
    createAction(SET_LANGUAGE_REGION, payload),
  setErrorPage: (payload: boolean) => createAction(SET_ERROR_FLAG, payload),
  setLoginModal: (payload: boolean) => createAction(SET_LOGIN_FLAG, payload),
  setServerErrorModal: (payload: boolean) =>
    createAction(SET_ERROR_MODAL_FLAG, payload),
  setNotFoundPage: (payload: boolean) =>
    createAction(SET_NOT_FOUND_FLAG, payload),
  setIsApp: (payload: boolean) => createAction(SET_IS_APP, payload),
  setUploadServerErrorModal: (payload: boolean) =>
    createAction(SET_UPLOAD_ERROR_MODAL_FLAG, payload),
  setOutfitChangeOrderFlag: (payload: boolean) =>
    createAction(SET_OUTFIT_CAHNGE_ORDER_FLAG, payload),
  setTagDotActive: (payload: boolean) =>
    createAction(SET_TAG_DOT_ACTIVE, payload)
};

type ActionType = ActionsUnion<typeof Actions>;
type LanguageRegionType = Pick<AppStateType, "language" | "region">;

const initialState: AppStateType = {
  brand_name: getBrand(),
  language: getLanguageFromUrl(),
  region: getRegionFromUrl(),
  isVisibleError: false,
  isVisibleLogin: false,
  isVisibleNotFound: false,
  isApp: false,
  isVisibleErrorModal: false,
  isOutfitFilterError: false,
  isOutfitOrderError: false,
  isVisibleUploadErrorModal: false,
  changeItemOrderFlag: false,
  changeOutfitOrderFlag: false,
  isTagDotActive: true
};

export default (
  state: AppStateType = initialState,
  action: ActionType
): AppStateType => {
  switch (action.type) {
    case SET_LANGUAGE_REGION: {
      if (action.payload.language) changeHtmlLanguage(action.payload.language);
      return { ...state, ...action.payload };
    }
    case SET_ERROR_FLAG: {
      return { ...state, isVisibleError: action.payload };
    }
    case SET_LOGIN_FLAG: {
      return { ...state, isVisibleLogin: action.payload };
    }
    case SET_ERROR_MODAL_FLAG: {
      return { ...state, isVisibleErrorModal: action.payload };
    }
    case SET_NOT_FOUND_FLAG: {
      return { ...state, isVisibleNotFound: action.payload };
    }
    case SET_IS_APP:
      return { ...state, isApp: action.payload };
    case SET_UPLOAD_ERROR_MODAL_FLAG: {
      return { ...state, isVisibleUploadErrorModal: action.payload };
    }
    case SET_OUTFIT_CAHNGE_ORDER_FLAG: {
      return { ...state, changeOutfitOrderFlag: action.payload };
    }
    case SET_TAG_DOT_ACTIVE: {
      return { ...state, isTagDotActive: action.payload };
    }
    default:
      return state;
  }
};
